import * as actionsTypes from '../actionTypes';

const INITIAL_STATE = {
  forms: [],
  selectedForm: null,
  formResponses: [],
  selectedFormResponseNo: null,
  selectedTableCell: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case actionsTypes.CLEAR_FORM_LIST_RESPONSES:
      return {
        ...state,
        formResponses: []
      };

    case actionsTypes.TOGGLE_FORM_LIST_RESPONSE:
      return {
        ...state,
        selectedFormResponseNo: action.payload
      };

    case actionsTypes.SET_FORM_LIST_RESPONSES:
      return {
        ...state,
        formResponses: action.payload
      };

    case actionsTypes.SET_FORMS_LIST:
      return {
        ...state,
        forms: action.payload
      };
    case actionsTypes.TOGGLE_FORM_LIST:
      return {
        ...state,
        selectedForm: action.payload
      };

    default:
      return state;
  }
}
